import { useState } from 'react';
import React from 'react'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

const faqData = [
    {
        id: 0,
        qs: 'When can I mint?',
        ans: 'Our exact mint date is TBD, but sometime early-mid November.'
    },
    {
        id: 1,
        qs: 'How how many different traits do G-Foxes have?',
        ans: 'G-Foxes have a total of 150 different unique 3D assets across 9 categories. '
    },
    {
        id: 2,
        qs: 'What is the max mint per transaction?',
        ans: 'The max mint per transaction is TBA.'
    },
    {
        id: 3,
        qs: 'Is there a rarity chart?',
        ans: 'Yes, there will be a full rarity chart available shortly after launch.'
    },
    {
        id: 4,
        qs: 'Which secondary market will you use?',
        ans: 'TBD'
    },
    {
        id: 5,
        qs: 'Will Bounty be listed?',
        ans: 'All proceeds from the first 272 G-Foxes sold will be set aside for the LP for Bounty. As soon as we launch, LP will be added to a DEX and Bounty will be freely exchangeable'
    },
]

const Faq = () => {
    const [activeFaq, setActiveFaq] = useState(null);
    return (
        <div className="faq-bg w-100">
            <div className="container py-5 " id="faq">
                <div className="row">
                    <div className="col-12 pt-3 pb-3">
                        <h1 className="sec-heading text-white py-md-0 pt-2 text-center">FAQs</h1>
                    </div>
                    <div className="col-12 px-3">
                        {faqData.map((data, i) => {
                            return (
                                <div
                                // data-aos="fade-up"
                                // data-aos-offset="500"
                                 key={i} className={`faq-wrapper ${activeFaq === i ? 'active-faq' : ''}`}>
                                    <div className="faq-qs" onClick={() => setActiveFaq(prev => prev === i ? null : i)}>
                                        <h6>{data.qs}</h6><span className="faq-arrow"><ArrowForwardIosIcon /></span>
                                    </div>
                                    <div className="faqs-answer text-white">
                                        <p>
                                            {data.ans}
                                        </p>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Faq
